// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"yj-z"};